<template>
    <div class="components-homepage-header">
        <div class="stepTopContent">
            <ol>
                <li>手机扫码，建议安卓使用京东app扫，IOS使用微信扫，IOS如果使用京东app扫，需要点击home键退出至后台，再进入京东app才可正常抓取上报数据；</li>
                <li>手机端点击开启按钮；</li>
                <li>打开京东app进行抓取上报数据；</li>
                <li>杀掉程序（iOS双击home键，上滑APP强制终止程序），会自动停止抓取数据。需要点击重新扫码，重新扫描二维码.</li>
            </ol>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mobile-homepageheader"
    }
</script>

<style lang="scss">
    .components-homepage-header {
        height: 100%;
        background: #FFFFFF !important;
        width:100%;
        text-align: center;

        .stepTopContent {
            font-size: 16px;
            line-height: 18px;
            font-family: PingFangSC-Regular;
            display: block;
            margin:0 auto;
            width:700px;
            text-align: left;

            li {
                line-height:35px;
            }
        }
    }
</style>

